// UI copy shared by the training trigger modal and the training list.
// Architecture/sample-rate choices come from GET /api/experiments/training-options.
// The experiment version a Cochl DB creates for itself: it carries the DB's
// base model, so manual trainings target a later experiment (mirrors
// Experiment.BASE_EXP_VER, which the trigger endpoint rejects).
export const BASE_EXP_VER = "v0"

export const TRAINING_MODES = {
    single: {
        label: "Single",
        description: "Train the selected model from scratch.",
    },
    distill: {
        label: "Distill",
        description: "Distill knowledge from trained teacher models into the selected student model.",
    },
}
